import { io } from 'socket.io-client';
import environment from './environment';

const URL = environment.api || window.location.host

export const socket = io(URL);